import DialogHapusUmum from "./src/DialogHapusUmum";

export default DialogHapusUmum